export enum ClosureCodes {
    GET_CLOSURE_CODES = "GET_CLOSURE_CODES",
    GET_CLOSURE_CODES_SUCCESS = "GET_CLOSURE_CODES_SUCCESS",
    GET_CLOSURE_CODES_FAIL = "GET_CLOSURE_CODES_FAIL",

    ADD_CLOSURE_CODES = "ADD_CLOSURE_CODES",
    ADD_CLOSURE_CODES_SUCCESS = "ADD_CLOSURE_CODES_SUCCESS",
    ADD_CLOSURE_CODES_FAIL = "ADD_CLOSURE_CODES_FAIL",

    OPEN_CLOSURE_CODE_DRAWER = "OPEN_CLOSURE_CODE_DRAWER",

    UPDATE_CLOSURE_CODES = "UPDATE_CLOSURE_CODES",

    GET_CLOSURE_CODE_HISTORY = "GET_CLOSURE_CODE_HISTORY",
    GET_CLOSURE_CODE_HISTORY_SUCCESS = "GET_CLOSURE_CODE_HISTORY_SUCCESS",
    GET_CLOSURE_CODE_HISTORY_FAIL = "GET_CLOSURE_CODE_HISTORY_FAIL",

    DELETE_CLOSURE_CODE = "DELETE_CLOSURE_CODE",
    DELETE_CLOSURE_CODE_SUCCESS = "DELETE_CLOSURE_CODE_SUCCESS",
    DELETE_CLOSURE_CODE_FAIL = "DELETE_CLOSURE_CODE_FAIL",
}
